import { render, staticRenderFns } from "./DeleteTagModal.vue?vue&type=template&id=5ca98752&scoped=true&"
import script from "./DeleteTagModal.vue?vue&type=script&lang=js&"
export * from "./DeleteTagModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteTagModal.vue?vue&type=style&index=0&id=5ca98752&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca98752",
  null
  
)

export default component.exports